import {
  GET_SPECIALIST_PROVIDER,
  GET_SPECIALIST_PROVIDER_FAILURE,
  GET_SPECIALIST_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getSpecialistProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SPECIALIST_PROVIDER:
      return { ...state, loading: true };
    case GET_SPECIALIST_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_SPECIALIST_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getSpecialistProviderReducer;
